// SearchableUserSelect component
// UPDATED: Simplified wrapper around SearchableSelect component
// Features: Search filtering by full name, displays only full name (no RoleBadge in list)
// Used in AssignmentModal and other places for user selection

import { getFullName } from '../../lib/supabase';
import { SearchableSelect } from './SearchableSelect';
import type { UserRole } from '../../lib/roleThemes';

interface User {
  id: string;
  first_name: string;
  last_name: string;
  username: string;
  role: UserRole;
}

interface SearchableUserSelectProps {
  users: User[];
  selectedUserId: string;
  onUserSelect: (userId: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  label?: string;
  required?: boolean;
}

export function SearchableUserSelect({
  users,
  selectedUserId,
  onUserSelect,
  placeholder = 'Sélectionnez un utilisateur',
  disabled = false,
  className = '',
  label,
  required = false
}: SearchableUserSelectProps) {
  // Transform users to options
  const options = users.map(user => ({
    value: user.id,
    label: getFullName(user)
  }));

  // Custom filter function to search by full name
  const filterFn = (option: { value: string; label: string }, query: string) => {
    const user = users.find(u => u.id === option.value);
    if (!user) return false;

    const searchQuery = query.toLowerCase();
    const fullName = getFullName(user).toLowerCase();
    return fullName.includes(searchQuery);
  };

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <SearchableSelect
        value={selectedUserId}
        onChange={onUserSelect}
        options={options}
        placeholder={placeholder}
        searchPlaceholder="Rechercher un utilisateur..."
        disabled={disabled}
        filterFn={filterFn}
      />
    </div>
  );
}
